import {Props} from '@peachy/utility-kit-pure'
import {PaymentEvent} from './PaymentEvent'


export class MrPaymentSucceeded extends PaymentEvent {
    constructor(from: Props<MrPaymentSucceeded>) {
        super(from)
    }
}
